export default __webpack_public_path__ + "static/media/qr-code-generator.3516cf45.png";